<!--
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
-->
<!--
Program: Excel Download
Author: SDL
Description: Excel Download Common Component
-->
<template>
  <button type="button" :class="btnClass" @click="excelDownload()">{{ $t(btnLabel) }}</button>
</template>
<script>
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';

export default {
  name: 'ExcelDownload',
  props: {
    btnLabel: {
      required: false,
      type: String,
      default: 'sdl.common.label.excelDownload',
    },
    btnClass: {
      type: String,
      default: 'btn btn-secondary',
    },
    excelInfo: {
      required: false,
      type: Object,
    },
    beforeClick: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * param:
     * return:
     * exception:
     * Description : click excel down
     */
    excelDownload() {
      if (this.beforeClick()) {
        this.download();
      }
      /* SDLUtil.confirm({
        msg: 'sdl.common.message.doExcelDownload',
        // title: 'confirm title',
        // okLabel: 'ok label',
        // cancelLabel: 'Cancel',
        onOkEvt: () => this.download(),
      }); */
    },
    /**
     * param:
     * return:
     * exception:
     * Description : execute download
     */
    download() {
      const getFileName = contentDisposition => {
        const fileName = contentDisposition
          .split(';')
          .filter(ele => ele.indexOf('filename') > -1)
          .map(ele => ele.replace(/"/g, '').split('=')[1]);
        return fileName[0] ? fileName[0] : null;
      };

      if (this.excelInfo.param.sftp !== true) {
        SDLUtil.showLoadingBar(true);
      }

      const param = [];
      const encodeList = ['columnInfoFile', 'fileName', 'sheetName', 'param'];
      Object.keys(this.excelInfo).forEach(val => {
        if (encodeList.includes(val)) {
          if (val === 'param') {
            param.push(`${val}=${encodeURIComponent(JSON.stringify(this.excelInfo[val]))}`);
          } else {
            param.push(`${val}=${encodeURIComponent(this.excelInfo[val])}`);
          }
        } else {
          param.push(`${val}=${this.excelInfo[val]}`);
        }
      });

      console.log('Excel Download Param');
      console.log(param);
      console.log(this.excelInfo);

      if (this.excelInfo.param.sftp !== true && this.excelInfo.param.paxataApi !== true) {
        console.log('Excel normal');
        axios({
          url: `${SDLUtil.API_URL}/excel/excel-download?${param.join('&')}`,
          responseType: 'arraybuffer',
          method: 'get',
        })
          .then(response => {
            try {
              const blob = new Blob([response.data], { type: response.headers['content-type'] });
              let fileName = '';
              if (response.headers['content-disposition']) {
                fileName = getFileName(response.headers['content-disposition']);
              } else {
                // eslint-disable-next-line prefer-destructuring
                fileName = this.excelInfo.fileName;
              }

              fileName = decodeURI(fileName); // File name decoding (option of use according to project)

              if (this.excelInfo.param.sftp !== true) {
                if (window.navigator.msSaveOrOpenBlob) {
                  // IE 10+
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                  // not IE
                  const link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  link.target = '_self';
                  if (fileName) link.download = fileName;
                  link.click();
                }
                console.log('ExcelDownload ResponseData');
                console.log(fileName);
                console.log(blob);
                SDLUtil.showLoadingBar(false);
              }
              // return response.data;
            } catch (e) {
              SDLUtil.showLoadingBar(false);
              console.error(e);
              console.log('Excel Download Error');
              console.log(e);
            }
          })
          .catch(response => {
            SDLUtil.showLoadingBar(false);
            if (response.data === null || response.data === '') {
              SDLUtil.alert('엑셀 다운로드에 실패했습니다.');
            } else {
              SDLUtil.alert(response.data);
            }
            console.log('Excel Download Error');
            console.log(response);
          });
      } else if (this.excelInfo.param.paxataApi === true) {
        this.excelInfo.param.sftp = false;
        console.log(this.excelInfo);
        console.log('Excel paxata');
        SDLUtil.showLoadingBar(false);
        try {
          axios({
            url: `${SDLUtil.API_URL}/excel/excel-download/paxataApi?${param.join('&')}`,
            method: 'get',
          });
        } catch (e) {
          console.log(e);
        }
        SDLUtil.toastSuccess('엑셀 파일 생성 요청되었습니다.');
      } else {
        console.log('Excel sftp upload');
        try {
          axios({
            url: `${SDLUtil.API_URL}/excel/excel-download?${param.join('&')}`,
            method: 'get',
          });
        } catch (e) {
          console.log(e);
        }
        SDLUtil.toastSuccess('엑셀 파일 생성 요청되었습니다.\n데이터의 사이즈에 따라 파일 생성에 시간(5분이상)이 소요될 수 있습니다.');
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/common/control/excel/ExcelDownload.vue